import { render, staticRenderFns } from "./RecettePopUpIngredients.vue?vue&type=template&id=2940f436&scoped=true&"
import script from "./RecettePopUpIngredients.vue?vue&type=script&lang=js&"
export * from "./RecettePopUpIngredients.vue?vue&type=script&lang=js&"
import style0 from "./RecettePopUpIngredients.vue?vue&type=style&index=0&id=2940f436&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2940f436",
  null
  
)

export default component.exports